import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { isMealCreditExpired } from 'src/components/oneCorp/features/MealCredit/utils/isMealCreditExpired';
import { pushError } from 'src/utilities/notifications';

export interface UseRedirectExpiredMealCreditProps {
  mealCredit: IMealCredit | null;
  corpId: string;
}

export function useRedirectExpiredMealCredit({
  mealCredit,
  corpId,
}: UseRedirectExpiredMealCreditProps): boolean {
  const { push } = useHistory();
  const [isMealCreditActive, setIsMealCreditActive] = useState(false);

  useEffect(() => {
    const isExpired = isMealCreditExpired(mealCredit);

    if (isExpired) {
      pushError('This meal credit has expired and is no longer accessible');
      push(`/corporate/enterprise/${corpId}/meal-credits`);
      return;
    }

    if (mealCredit) {
      setIsMealCreditActive(true);
    }
  }, [mealCredit, corpId, push]);

  return isMealCreditActive;
}
